module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "header"
  }, [_h('div', {
    staticClass: "content-wrapper"
  }, [_h('div', {
    staticClass: "avatar"
  }, [_h('img', {
    attrs: {
      "width": "64",
      "height": "64",
      "src": _vm.seller.avatar
    }
  })]), " ", _h('div', {
    staticClass: "content"
  }, [_h('div', {
    staticClass: "title"
  }, [_h('span', {
    staticClass: "brand"
  }), " ", _h('span', {
    staticClass: "name"
  }, [_vm._s(_vm.seller.name)])]), " ", _h('div', {
    staticClass: "description"
  }, ["\n        " + _vm._s(_vm.seller.description) + "/" + _vm._s(_vm.seller.deliveryTime) + "分钟送达\n      "]), " ", (_vm.seller.supports) ? _h('div', {
    staticClass: "support"
  }, [_h('span', {
    staticClass: "icon",
    class: _vm.classMap[_vm.seller.supports[0].type]
  }), " ", _h('span', {
    staticClass: "text"
  }, [_vm._s(_vm.seller.supports[0].description)])]) : _vm._e()]), " ", (_vm.seller.supports) ? _h('div', {
    staticClass: "supports-count",
    on: {
      "click": _vm.showDetail
    }
  }, [_h('span', {
    staticClass: "count"
  }, [_vm._s(_vm.seller.supports.length) + "个"]), " ", _h('i', {
    staticClass: "icon iconfont icon-zuoyoujiantou"
  })]) : _vm._e()]), " ", _h('div', {
    staticClass: "bulletin-wrapper",
    on: {
      "click": _vm.showDetail
    }
  }, [_h('span', {
    staticClass: "bulletin-title"
  }), _h('span', {
    staticClass: "bulletin-text"
  }, [_vm._s(_vm.seller.bulletin)]), " ", _h('i', {
    staticClass: "icon iconfont icon-zuoyoujiantou"
  })]), " ", _h('div', {
    staticClass: "background"
  }, [_h('img', {
    attrs: {
      "src": _vm.seller.avatar,
      "alt": "",
      "width": "100%",
      "height": "100%"
    }
  })]), " ", _h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailShow),
      expression: "detailShow"
    }],
    staticClass: "detail",
    attrs: {
      "transition": "fade"
    },
    on: {
      "click": _vm.hideDetail
    }
  }, [_h('div', {
    staticClass: "detail-wrapper clearFix"
  }, [_h('div', {
    staticClass: "detail-main"
  }, [_h('h1', {
    staticClass: "name"
  }, [_vm._s(_vm.seller.name)]), " ", _h('div', {
    staticClass: "star-wrapper"
  }, [_h('star', {
    attrs: {
      "size": 48,
      "score": _vm.seller.score
    }
  })]), " ", _h('div', {
    staticClass: "title"
  }, [_h('div', {
    staticClass: "line"
  }), " ", _h('div', {
    staticClass: "text"
  }, ["优惠信息"]), " ", _h('div', {
    staticClass: "line"
  })]), " ", (_vm.seller.supports) ? _h('ul', {
    staticClass: "supports"
  }, [_vm._l((_vm.seller.supports), function(item, index) {
    return _h('li', {
      staticClass: "support-item"
    }, [_h('span', {
      staticClass: "icon",
      class: _vm.classMap[_vm.seller.supports[index].type]
    }), " ", _h('span', {
      staticClass: "text"
    }, [_vm._s(_vm.seller.supports[index].description)])])
  })]) : _vm._e(), " ", _h('div', {
    staticClass: "title"
  }, [_h('div', {
    staticClass: "line"
  }), " ", _h('div', {
    staticClass: "text"
  }, ["商家公告"]), " ", _h('div', {
    staticClass: "line"
  })]), " ", _h('div', {
    staticClass: "bulletin"
  }, [_h('p', {
    staticClass: "content"
  }, [_vm._s(_vm.seller.bulletin)])])])]), " ", _h('div', {
    staticClass: "detail-close",
    on: {
      "click": _vm.hideDetail
    }
  }, [_h('i', {
    staticClass: "iconfont icon-cha"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-ab428840!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 53
// module chunks = 1